// extracted by mini-css-extract-plugin
export default {"container":"FilesDialog_container__dwWBS","description":"FilesDialog_description__g-TeI","buttons":"FilesDialog_buttons__RRaJA"};